export enum RecommendationStatus {
    Success = 'success',
    Failure = 'no-recommendations'
}
